import * as React from 'react'
import {inject} from 'mobx-react'
import {compose} from 'recompose'
import {ViewConfig, RouteChildren, withRoute, RouteProps} from '@eda.yandex/web-router'
import {RouterEnv} from 'admin/types'
import {StoreType} from 'admin/models/Store'
import injectSheet, {WithClasses} from '@eda.yandex/ui-kit/lib/hocs/inject-sheet'
import {createStyles} from '@eda.yandex/ui-kit/lib/jss'
import {Avatar, Dropdown, Menu, Layout} from 'antd'
import * as cookie from 'js-cookie'
import {ANCHOR_CLICK_EVENT_TITLE, ANCHOR_CLICK_EVENT_DETAILS} from 'widgets/sidebar/menu'
import {isAbsoluteUrl} from 'common/lib/url'

type OuterProps = {}
type InnerProps = OuterProps & WithClasses<typeof styles> & RouteProps &  {
  store: StoreType
}

const {Header, Footer, Content} = Layout
const styles = createStyles({
  '@global': {
    'body, #root': {
      display: 'flex',
      flex: 1
    }
  },
  root: {
    display: 'flex',
    flex: 1
  },
  layout: {
    maxWidth: '100vw'
  },
  content: {
    flex: '1 0 auto',
    display: 'flex',
    flexDirection: 'column'
  },
  header: {
    background: '#fff',
    boxShadow: '0 1px 4px rgba(0,21,41,.08)',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1
  },
  sidebarMenu: {
    borderTop: '1px solid rgba(255, 255, 255, 0.13)',
    paddingTop: 15
  },
  avatar: {
  },
  footer: {
    flex: '0 0 auto'
  }
})

class App extends React.Component<InnerProps> {
  private layoutRef: HTMLElement | null | undefined = undefined

  componentDidMount () {
    this.layoutRef!.addEventListener(ANCHOR_CLICK_EVENT_TITLE, this.sidebarAnchorClickHandler as any)
  }

  sidebarAnchorClickHandler = (customEvent: CustomEvent<ANCHOR_CLICK_EVENT_DETAILS>) => {
    // handle separate sidebar link click events to make page transition SPA-style
    const originalEvent = customEvent.detail.originalEvent
    const href = (originalEvent as any).target.getAttribute('href')

    if (!isAbsoluteUrl(href)) {
      originalEvent.preventDefault()
      this.props.routeManager.history.push(href)
    }
  }

  renderHeaderDropdown () {
    const yu = cookie.get('yandexuid')

    return (
      <Menu>
        <Menu.Item>
          <a target='_blank' href='https://staff.yandex-team.ru/'>Профиль</a>
        </Menu.Item>
        <Menu.Item>
          <a href={`https://passport.yandex-team.ru/passport?mode=logout&yu=${yu}&retpath=${location.href}`}>Выйти</a>
        </Menu.Item>
      </Menu>
    )
  }

  render () {
    const {classes: c} = this.props
    const {user} = this.props.store

    return (
      <div className={c.root}>
        <Layout hasSider className={c.layout}>
            <global-sidebar
              ref={(ref: any) => this.layoutRef = ref}
              backOfficeBaseUrl=''
            />
          <Layout>
            <Header className={c.header}>
              <Dropdown overlay={this.renderHeaderDropdown()} placement='bottomRight' trigger={['click']}>
                <Avatar src={user.avatar} className={c.avatar} size={40} />
              </Dropdown>
            </Header>
            <Content className={c.content}>
              <RouteChildren />
            </Content>
            <Footer className={c.footer}>Footer</Footer>
          </Layout>
        </Layout>
      </div>
    )
  }
}

const EnhancedApp = compose<InnerProps, OuterProps>(
  injectSheet(styles, 'App'),
  withRoute,
  inject('store')
)(App)

const viewConfig: ViewConfig<RouterEnv> = {
  Component: EnhancedApp,
  displayName: 'App',
  async controller (_route, env) {
    env.store.ui.setGlobalLoader(true)
    try {
      await env.store.initialize()
      if (!env.store.user.profile) {
        return {
          redirect: {
            to: `https://passport.yandex-team.ru/passport?mode=auth&retpath=${location.href}`
          }
        }
      }

      return undefined
    } finally {
      env.store.ui.setGlobalLoader(false)
    }
  }
}

export default viewConfig
